import { useMutation } from "@tanstack/react-query";
import { PaymixService } from "../../services/paymix.service";

export const usePaymentMethodsMutations = () => {
  const { mutate: saveCard } = useMutation<
    any,
    Error,
    { userId: string; cardDetails: string; redirectUrl: string }
  >({
    mutationFn: async ({ userId, cardDetails, redirectUrl }) => {
      return PaymixService.attachPaymentMethod(userId, cardDetails, redirectUrl);
    },
  });

  const { mutate: deleteCard } = useMutation<any, Error, { id: string }>({
    mutationFn: async ({ id }) => {
      return PaymixService.detachPaymentMethod(id);
    },
  });

  const { mutate: changeDefaultCard } = useMutation<
    any,
    Error,
    { userId: string; referenceId: string }
  >({
    mutationFn: async ({ userId, referenceId }) => {
      return PaymixService.changeDefaultPaymentMethod({ userId, referenceId });
    },
  });

  return {
    saveCard,
    deleteCard,
    changeDefaultCard,
  };
};
